import type {
    Region,
    Languages,
} from '@amp/web-app-components/src/components/buttons/LocaleSwitcherButton/types';
import type { StorefrontNames } from '@amp/web-app-components/src/components/banners/types';

// The TS ignores play an important role in concert with the vi.mock() in
// tests/setup-vitest.ts. The files referenced here are generated by
// shared/config/src/plugins/rollup-plugin-get-storefronts.js. They will not
// exist when tests are run in CI (or from a clean install). Thus, they need to
// be mocked out. But, Jest mocks do nothing to convince TypeScript of a file
// that doesn't exist. So, we must ignore these imports for TS purposes to
// avoid the tests failing to even compile with tsc (before they can even be
// run and have jest mock them out).

import {
    regions as outputtedRegions,
    languages as outputtedLanguages,
} from 'virtual:storefronts';
import { getFormattedStorefrontNameTranslations } from '@amp/web-app-storefronts';

export const regions: Region[] = outputtedRegions;
export const languages: Languages = outputtedLanguages;
export const storefrontNameTranslations: StorefrontNames =
    getFormattedStorefrontNameTranslations(regions);
